import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import styled from "styled-components";

type RankingLinkProps = {
  href: string | null | undefined;
  compact?: boolean;
};

const Link = styled.a<{ $compact: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: ${({ $compact }) => ($compact ? "32px" : "36px")};
  padding: ${({ $compact }) => ($compact ? "6px 10px" : "8px 14px")};
  border: 1px solid #0B4FA8;
  border-radius: 999px;
  background: #ffffff;
  color: #0B4FA8;
  font-size: ${({ $compact }) => ($compact ? "12px" : "13px")};
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  transition:
    background-color 0.18s ease,
    color 0.18s ease,
    box-shadow 0.18s ease;

  &:hover {
    background: #0B4FA8;
    color: #ffffff;
    box-shadow: 0 3px 10px rgba(25, 103, 210, 0.2);
  }

  &:focus-visible {
    outline: 3px solid rgba(66, 133, 244, 0.3);
    outline-offset: 2px;
  }
`;

export const RankingLink = ({ href, compact = false }: RankingLinkProps) => {
  if (!href) return null;

  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Ver link da consulta"
      $compact={compact}
    >
      <OpenInNewIcon sx={{ fontSize: compact ? 15 : 17 }} />
      Ver link
    </Link>
  );
};
